import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { FaUserCircle, FaSignOutAlt, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import './header.css';

const Headers = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear authentication data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('role');

    // Reload to force navigation to login
    setTimeout(() => {
      window.location.href = '/admin/login';
    }, 1); // 100 ms delay
  };

  const handleProfileClick = () => {
    // Navigate to the profile page
    navigate('/profile'); // Ensure the path is correct
  };

  return (
    <Navbar variant="dark" expand="lg" className="w-100 header" style={{ zIndex: 999 }}>
      <div className="d-flex justify-content-between w-100">
        <Nav>
          <Nav.Link onClick={() => { 
            console.log("Sidebar toggle clicked");
            toggleSidebar(); 
          }} className="text-white">
            <FaBars size={24} />
          </Nav.Link>
        </Nav>
        <Nav className="nav-right">
          <Nav.Link onClick={handleProfileClick} className="text-white">
            <FaUserCircle size={24} />
          </Nav.Link>
          <Nav.Link onClick={handleLogout} className="text-white">
            <FaSignOutAlt size={24} />
          </Nav.Link>
        </Nav>
      </div>
    </Navbar>
  );
};

export default Headers;